import { render, staticRenderFns } from "./ShiftWorkSummaryForm.vue?vue&type=template&id=5170d67c&scoped=true"
import script from "./ShiftWorkSummaryForm.vue?vue&type=script&lang=js"
export * from "./ShiftWorkSummaryForm.vue?vue&type=script&lang=js"
import style0 from "./ShiftWorkSummaryForm.vue?vue&type=style&index=0&id=5170d67c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5170d67c",
  null
  
)

export default component.exports